import { render, staticRenderFns } from "./BattleShip.vue?vue&type=template&id=28088e32"
import script from "./BattleShip.vue?vue&type=script&lang=js"
export * from "./BattleShip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports